// components/layout/Section.tsx
import React from 'react';
import { SectionProps } from '../../types/index';

const Section: React.FC<SectionProps> = ({
                                           title,
                                           children,
                                           className = '',
                                           bg = 'bg-white'
                                         }) => (
  <section className={`py-12 md:py-20 ${bg} ${className}`}>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      {title && (
        <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-800 mb-10 md:mb-16">
          {title}
        </h2>
      )}
      {children}
    </div>
  </section>
);

export default Section;
